// extracted by mini-css-extract-plugin
export default {"icon":"Locked_icon__eQTtP"};